import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import Constraint from 'js/components/Constraint';

import Backdrop from 'js/components/core/Backdrop';
import Title from 'js/components/core/SteppedPage/Title';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import SizeSelector from './SizeSelector';

@inject('page')
@observer
export default class SizeDetails extends Component {
  render() {
    const page = this.props.page;
    return (
      <>
        <Backdrop>
          <Title>Size</Title>
          <SubTitle>How large is your item?</SubTitle>
        </Backdrop>

        <Constraint>
          <SizeSelector size={page.size} onChange={page.setSize} />

          <ProgressRow margin="2rem">
            <ContinueButton onClick={page.nextStep}>Continue</ContinueButton>
            <StepStatus />
          </ProgressRow>
        </Constraint>
      </>
    );
  }
}
